const scriptTag = document.createElement('script');
scriptTag.src = "https://cdn.mazing.link/mzg-in.js";
scriptTag.type = "text/javascript";
scriptTag.crossOrigin = "anonymous";
scriptTag.defer = true;
document.head.append(scriptTag);

/* --- State --- */
let iframeSrc;
let iframeElement;
let overlayEl;
let closeBtnEl;
let loaderEl;
let isModelLoaded = false;

const customer = "MIKEMYSTICBARRELSCOM";
let currentVariants = [];

console.log('Mazing Integration v1.2 (with loader overlay)');

const waitForMazingFunction = new Promise((resolve) => {
    const t = setInterval(() => {
        if (typeof window.mazingProjectAvailable === "function") {
            clearInterval(t);
            resolve();
        }
    }, 50);
});

const waitForElement = (sel, timeout = 55000) => new Promise((resolve) => {
    let elapsed = 0;
    const t = setInterval(() => {
        const el = document.querySelector(sel);
        if (el) {
            clearInterval(t);
            resolve(el);
        } else if ((elapsed += 50) >= timeout) {
            clearInterval(t);
            resolve();
        }
    }, 50);
});

const getCurrentSKU = () => {
    const url = window.location.href;
    const parts = url.split("/").filter(Boolean);
    const product = parts[parts.length - 1].split('?')[0];
    return product.toLowerCase();
};

const createOverlayInGallery = (galleryContainer) => {
    const style = window.getComputedStyle(galleryContainer);
    if (style.position === 'static') galleryContainer.style.position = 'relative';

    overlayEl = document.createElement('div');
    overlayEl.className = 'mazing-overlay';
    overlayEl.setAttribute('aria-hidden', 'true');
    Object.assign(overlayEl.style, {
        position: 'absolute', inset: '0', zIndex: '100', pointerEvents: 'auto'
    });

    const inner = document.createElement('div');
    inner.className = 'mazing-overlay-inner';
    Object.assign(inner.style, {
        position: 'absolute', inset: '0', background: '#fff', borderRadius: '8px',
        boxShadow: '0 8px 24px rgba(0,0,0,.18)', overflow: 'hidden'
    });

    closeBtnEl = document.createElement('button');
    closeBtnEl.type = 'button';
    closeBtnEl.setAttribute('aria-label', 'Close 3D viewer');
    closeBtnEl.innerHTML = '&times;';
    Object.assign(closeBtnEl.style, {
        position: 'absolute', top: '30px', right: '10px', width: '80px', height: '50px',
        lineHeight: '32px', fontSize: '24px', fontWeight: '700', borderRadius: '9999px',
        background: 'rgba(255,255,255,0.92)', border: '1px solid rgba(0,0,0,.12)',
        cursor: 'pointer', zIndex: '3'
    });

    iframeElement = document.createElement('iframe');
    Object.assign(iframeElement.style, {
        position: 'absolute',
        inset: '0',
        width: '100%',
        height: '100%',
        border: 'none',
        zIndex: '0'
    });
    iframeElement.allow = "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; camera *; xr-spatial-tracking;";
    iframeElement.loading = 'eager';

    loaderEl = document.createElement('div');
    Object.assign(loaderEl.style, {
        position: 'absolute',
        inset: '0',
        background: 'transparent !important',
        display: 'none',
        alignItems: 'flex-end',
        justifyContent: 'center',
        padding: '18px',
        zIndex: '2',
        pointerEvents: 'auto',
        textAlign: 'center'
    });
    const loaderText = document.createElement('div');
    loaderText.innerHTML = `
      <div class="mm-title">Your interactive 3D barrel is loading & aging like a fine whiskey!</div>
      <div class="mm-sub">(Please allow up to 10 seconds)</div>
    `;
    Object.assign(loaderText.style, {
        maxWidth: 'min(820px, 92%)',
        width: 'fit-content',
        margin: '0 16px 70px',
        padding: '18px 22px',
        borderRadius: '16px',
        background: 'rgba(255,255,255,0.92)',
        boxShadow: '0 12px 34px rgba(0,0,0,.14), 0 2px 6px rgba(0,0,0,.06)',
        border: '1px solid rgba(0,0,0,.06)',
        backdropFilter: 'blur(6px) saturate(110%)',
        WebkitBackdropFilter: 'blur(6px) saturate(110%)',

        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        gap: '6px',

        color: '#111',
    });

    const titleEl = loaderText.querySelector('.mm-title');
    Object.assign(titleEl.style, {
        fontSize: 'clamp(18px, 2vw, 20px)',
        lineHeight: '1.25',
        fontWeight: '600',
        letterSpacing: '.2px',
        textWrap: 'balance',
    });

    const subEl = loaderText.querySelector('.mm-sub');
    Object.assign(subEl.style, {
        fontSize: 'clamp(13px, 1.6vw, 15px)',
        lineHeight: '1.35',
        color: '#444',
        opacity: '.85',
    });
    loaderEl.appendChild(loaderText);

    inner.appendChild(closeBtnEl);
    inner.appendChild(iframeElement);
    inner.appendChild(loaderEl);
    overlayEl.appendChild(inner);
    galleryContainer.appendChild(overlayEl);
};

const showLoader = () => {
    if (!loaderEl) return;
    loaderEl.style.display = 'flex';
};

const hideLoader = () => {
    if (!loaderEl) return;
    loaderEl.style.display = 'none';
};

const showOverlay = () => {
    if (!overlayEl) return;

    if (!isModelLoaded) showLoader();

    if (!iframeElement.src && iframeSrc) {
        iframeElement.src = iframeSrc;
    }

    overlayEl.classList.add('is-open');
    overlayEl.setAttribute('aria-hidden', 'false');
};

const hideOverlay = () => {
    if (!overlayEl) return;
    overlayEl.classList.remove('is-open');
    const onEnd = (e) => {
        if (e.propertyName === 'opacity') {
            overlayEl.setAttribute('aria-hidden', 'true');
            overlayEl.removeEventListener('transitionend', onEnd);
        }
    };
    overlayEl.addEventListener('transitionend', onEnd);
};

const initializeMazingButton = async () => {
    await mazing({
        customerName: customer,
        buttonConfiguration: {
            customStyle: `
                .mazing-button-container { z-index:0; display:flex; margin:24px 0 0; justify-content:center; }
                .mazing-threed-btn, .mazing-ar-btn { border:none !important; display:flex; gap:10px; padding:10px 24px; border-radius:5px; margin-right:0px; width:98%; justify-content:center !important; margin-bottom: 10px }
                .mazing-threed-btn-text, .mazing-ar-btn-text { font-weight:600; color:black; }
                .mazing-ar-btn, .mazing-threed-btn { display:none }
                .mazing-threed-btn-icon { filter: brightness(0) saturate(100%) invert(27%) sepia(12%) saturate(21%) hue-rotate(5deg) brightness(89%) contrast(84%); }
                
                                
                  .mazing-button-container .mazing-threed-btn:hover,
                  .mazing-button-container .mazing-threed-btn:active,
                  .mazing-button-container .mazing-threed-btn:focus,
                  .mazing-button-container .mazing-ar-btn:hover,
                  .mazing-button-container .mazing-ar-btn:active,
                  .mazing-button-container .mazing-ar-btn:focus {
                    border: 1px solid transparent !important;
                    background: transparent !important;
                    transform: none !important;
                    outline: none !important;
                    text-decoration: none !important;
                  }
            
                  .mazing-button-container .mazing-threed-btn::before,
                  .mazing-button-container .mazing-threed-btn::after,
                  .mazing-button-container .mazing-ar-btn::before,
                  .mazing-button-container .mazing-ar-btn::after {
                    content: none !important;
                  }
            `,
            placementSelector: '.media-wrapper',
            threedBtn: {enabled: true, icon: true, customText: "View in 3D"},
            arBtn: {enabled: false, icon: false, customText: ""}
        },
        getSKU: getCurrentSKU
    });

    const ensureButtonAtBottom = () => {
        const host = document.querySelector('.pwzrjss1');
        const btnWrap = host?.querySelector('.mazing-button-container');
        if (host && btnWrap && host.firstElementChild !== btnWrap) {
            host.insertBefore(btnWrap, host.firstElementChild);
        }
    };

    const hookMazingButton = () => {
        const btn = document.querySelector('.mazing-threed-btn');
        if (!btn || btn.__mazingHooked) return;

        const open = (e) => {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            showOverlay();
        };
        btn.addEventListener('click', open, true);
        btn.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') open(e);
        }, true);

        btn.__mazingHooked = true;
        ensureButtonAtBottom();
    };

    hookMazingButton();
    new MutationObserver(() => {
        hookMazingButton();
        ensureButtonAtBottom();
    }).observe(document.querySelector('.pwzrjss1') || document.body, {childList: true, subtree: true});
};

/* --- Helpers --- */
const slugify = (s) =>
    (s || "")
        .normalize("NFKD").replace(/[\u0300-\u036f]/g, "")
        .replace(/[“”"’‘']/g, "")
        .toLowerCase()
        .replace(/&/g, " and ")
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "")
        .replace(/-+/g, "-");

const getCurrentVariants = () => {
    const activeInputs = document.querySelectorAll('.choices input[type="radio"]:checked');
    if (!activeInputs) return [];

    const variants = [];
    for (let i = 0; i < activeInputs.length; i++) {
        const valueRaw = activeInputs[i].value;
        variants.push(slugify(valueRaw));
    }
    return variants;
};

const sendVariantsToIframe = () => {
    console.log('MAZING: sendVariantsToIframe ', currentVariants);
    if (iframeElement && iframeElement.contentWindow) {
        for (let i = 0; i < currentVariants.length; i++) {
            const payload = {type: 'SWITCH_VARIANT', value: {trigger: currentVariants[i]}};
            iframeElement.contentWindow.postMessage(payload, '*');
        }
    }
};

const initialVariants = () => {
    currentVariants = getCurrentVariants();
    console.log('MAZING: initialVariants listener applied ');

    function onMessage(event) {
        if (event.data?.type === 'MODEL_3D_LOADED') {
            console.log('MAZING: initial apply variants ');
            isModelLoaded = true;
            hideLoader();
            sendVariantsToIframe();

            window.removeEventListener('message', onMessage);
        }
    }
    window.addEventListener('message', onMessage);

    sendVariantsToIframe();
};

/* --- Choice-Listener (Buttons / Radios) --- */
const setupChoiceListeners = () => {

    document.querySelectorAll('.choices').forEach((box) => {
        if (box.__mazingHooked) return;
        box.__mazingHooked = true;

        box.addEventListener('click', () => {
            currentVariants = getCurrentVariants();

            // showOverlay();

            if (!iframeElement?.src && iframeSrc) {
                function onVariantButtonMessage(event) {
                    if (event.data?.type === 'MODEL_3D_LOADED') {
                        console.log('MAZING: variant button apply variants ');
                        isModelLoaded = true;
                        hideLoader();
                        sendVariantsToIframe();
                        window.removeEventListener('message', onVariantButtonMessage);
                    }
                }
                window.addEventListener('message', onVariantButtonMessage);

                iframeElement.src = iframeSrc;
            } else {
                console.log('MAZING: variant button apply variants (iframe pure) ');
                sendVariantsToIframe();
            }
        });
    });
};

// --- Smooth overlay styles ---
const injectMazingOverlayStyles = () => {
    if (document.getElementById('mazing-overlay-styles')) return;
    const styleTag = document.createElement('style');
    styleTag.id = 'mazing-overlay-styles';
    styleTag.textContent = `
    .mazing-overlay {
      position: absolute; inset: 0;
      opacity: 0;
      visibility: hidden;
      pointer-events: none;
      transition: opacity .28s ease, visibility 0s linear .28s;
      z-index: 100;
    }
    .mazing-overlay.is-open {
      opacity: 1;
      visibility: visible;
      pointer-events: auto;
      transition: opacity .28s ease;
    }

    .mazing-overlay .mazing-overlay-inner {
      position: absolute; inset: 0;
      background: #fff; border-radius: 8px;
      box-shadow: 0 8px 24px rgba(0,0,0,.18);
      overflow: hidden;
      transform: scale(.985);
      transition: transform .28s ease;
    }
    .mazing-overlay.is-open .mazing-overlay-inner {
      transform: scale(1);
    }

    @media (prefers-reduced-motion: reduce) {
      .mazing-overlay, .mazing-overlay .mazing-overlay-inner {
        transition: none !important;
      }
    }
  `;

    document.head.appendChild(styleTag);
}

/* ---- Init ---- */
(async () => {
    try {
        await waitForMazingFunction;

        const galleryContainer = await waitForElement('.main-slider');
        if (!galleryContainer) return;

        iframeSrc = await mazingProjectAvailable({customerName: customer, getSKU: getCurrentSKU});

        if (!iframeSrc) {
            console.log('MAZING: iframeSrc not found, aborting.');
            return;
        }

        createOverlayInGallery(galleryContainer);
        closeBtnEl.addEventListener('click', hideOverlay);

        window.addEventListener('message', (ev) => {
            if (ev?.data?.type === 'MODEL_3D_LOADED') {
                isModelLoaded = true;
                hideLoader();
            }
        });

        initialVariants();
        await initializeMazingButton();
        setupChoiceListeners();
        injectMazingOverlayStyles();

        const mazingBtn = document.querySelector('.mazing-threed-btn');
        setTimeout(() => {
            if (mazingBtn) {
                mazingBtn.style.display = 'flex';
            }
        }, 500);

        console.log('MAZING: Mazing overlay ready.');
    } catch (e) {
        console.error('Initialization failed:', e);
    }
})();